import {fromJsonObject, usingJsonToModelConvertor} from "../decorators";
import {Model} from "../Model";

export type OrderActions =
    "ctc_receipt_form" |
    "goto_ipg" |
    "active_order_information_page" |
    "show_branch_decline_page" |
    "show_delivery_decline_page";

@usingJsonToModelConvertor
export default class OrderAction extends Model{

    @fromJsonObject({key: 'action'})
    public action!: string;

    // @fromJsonObject({key: 'data'})
    // public data!: any;

}